module.exports = __webpack_public_path__ + "img/Jesse-Feder.e3a3ff99.jpeg";